import React from 'react'
import { Container } from 'reactstrap'
import {
  StyledContainer,
  LoadingPlaceholder
} from './styles'
export default () => {
  return (
    <Container>
      <StyledContainer>
        <LoadingPlaceholder h={300} wp={100} />
      </StyledContainer>
    </Container>
  )
}
